<template>

    <div>

        <v-panel class="maxw-600" :loading="starting">
            <template #title>Accepting Invite...</template>
            <template #body>
                <div v-if="companies.length">
                    <v-alert message="Invite accepted! Select a company to proceed." type="success" />
                    <v-list>
                        <v-list-item v-for="c in companies" :key="c.id">
                            <div class="d-flex align-items-center">
                                <v-avatar class="mr-10" :name="c.name" :url="c.logo ? c.logo.link : ''" />
                                <span>{{ c.name }}</span>
                            </div>
                            <div>
                                <v-button
                                    class="float-right"
                                    btn-label="Select"
                                    size="sm"
                                    :loading="company && company.id === c.id"
                                    @click.native="selectCompany(c)">
                                </v-button>
                            </div>
                        </v-list-item>
                    </v-list>
                </div>
                <div v-else>
                    <v-alert :message="error" />
                    <v-button @click.native="$router.push({ name: 'console' })" btn-block>Proceed to Console</v-button>
                </div>
            </template>
        </v-panel>

    </div>

</template>

<script>

import MemberInviteApi from '@api/MemberInviteApi';
import UserApi from '@api/UserApi';

export default {

    data() {
        return {
            starting: true,
            error: null,
            company: {},
            companies: [],
        }
    },

    mounted() {
        this.acceptMemberInvite();
    },

    methods: {

        acceptMemberInvite() {
            MemberInviteApi.acceptMemberInvite(this.$route.params.token)
                .then((response) => {
                    this.$store.commit('setInviteToken', null);
                    this.companies = response.data.data;
                    this.starting = false;
                }, (error) => {
                    this.error = error.response.data.message;
                    this.starting = false;
                });
        },

        selectCompany(company) {
            this.company = company;
            UserApi.updateCompany(company.id)
                .then((response) => {
                    this.company = null;
                    this.$router.push({ name: 'projects' });
                }, (error) => {
                    this.company = null;
                    this.error = error.response.data.message;
                });
        },

    },

}

</script>
